import styled from 'styled-components';

const BlogItemStyle = styled.div`
	--blogItemBorderRadius: var(--sp2x);
	--blogItemBottomContentPadTB: var(--sp4x);
	--blogItemBottomContentPadLR: var(--sp5x);
	--blogItemBottomContentGap: var(--sp3x);

	--blogItemImageSize: 109.8%;

	overflow: hidden;
	border-radius: var(--blogItemBorderRadius);

	.blog-item-info-wrapper {
		padding: var(--blogItemBottomContentPadTB) var(--blogItemBottomContentPadLR);
		background-color: var(--green100);
	}

	.blog-item-info-inner-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--blogItemBottomContentGap);
	}

	.blog-item-image-wrapper {
		overflow: hidden;
		isolation: isolate;
		backface-visibility: visible;
	}

	.image-cont {
		--proportion: var(--blogItemImageSize);

		will-change: transform;
		transition: transform 0.4s ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				.image-cont {
					transform: scale(1.1);
				}
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--blogItemBorderRadius: var(--sp2x);
		--blogItemBottomContentPadTB: var(--sp3x);
		--blogItemBottomContentPadLR: var(--sp4x);
		--blogItemBottomContentGap: var(--sp2x);

		--blogItemImageSize: 105.1%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--blogItemBorderRadius: var(--sp2x);
		--blogItemBottomContentPadTB: var(--sp3x);
		--blogItemBottomContentPadLR: var(--sp3x);
		--blogItemBottomContentGap: var(--sp2x);

		--blogItemImageSize: 103.8%;
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--blogItemBorderRadius: var(--sp2x);
		--blogItemBottomContentPadTB: var(--sp2-5x);
		--blogItemBottomContentPadLR: var(--sp3x);
		--blogItemBottomContentGap: var(--sp1-5x);

		--blogItemImageSize: 109.5%;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--blogItemBorderRadius: var(--sp1-5x);
		--blogItemBottomContentPadTB: var(--sp2x);
		--blogItemBottomContentPadLR: var(--sp2-5x);
		--blogItemBottomContentGap: var(--sp1-5x);

		--blogItemImageSize: 109.8%;
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--blogItemBorderRadius: var(--sp1-5x);
		--blogItemBottomContentPadTB: var(--sp2x);
		--blogItemBottomContentPadLR: var(--sp2x);
		--blogItemBottomContentGap: var(--sp1-5x);

		--blogItemImageSize: 109.8%;
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--blogItemBorderRadius: var(--sp1x);
		--blogItemBottomContentPadTB: var(--sp2x);
		--blogItemBottomContentPadLR: var(--sp2x);
		--blogItemBottomContentGap: var(--sp1x);

		--blogItemImageSize: 110%;
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--blogItemBorderRadius: var(--sp1x);
		--blogItemBottomContentPadTB: var(--sp2x);
		--blogItemBottomContentPadLR: var(--sp1-5x);
		--blogItemBottomContentGap: var(--sp1x);

		--blogItemImageSize: 109.7%;
	}
`;

export default BlogItemStyle;
